// @flow

import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import { Section, SectionContent, Wrapper } from '@riseart/layout';

import {
  homeTrendingCls,
  homeTrendingArrowCls,
} from 'shared_components/pages/home/sections/trending/Trending.less';

type Props = { children: Node, disableHeadingTags?: boolean, className?: string };

/**
 * HomeTrendingSection
 *
 * @param {Props} props
 * @returns {Node}
 */
export const HomeTrendingSection = ({ children, disableHeadingTags, className }: Props): Node =>
  children ? (
    <Section background="gray" {...(className ? { className } : null)}>
      <Wrapper>
        <SectionContent
          className={homeTrendingCls}
          title={
            <FormattedMessage id="components.activity.trending.title">
              {(title: string) => title}
            </FormattedMessage>
          }
          subTitle={
            <FormattedMessage id="components.activity.trending.subTitle">
              {(title: string) => title}
            </FormattedMessage>
          }
          headingProps={{
            tag: disableHeadingTags ? 'span' : 'h2',
            level: 2,
            align: 'center',
            uppercase: true,
          }}
          headingSubTitleProps={{
            tag: disableHeadingTags ? 'span' : 'h3',
            level: 5,
            align: 'center',
          }}
        >
          <span className={homeTrendingArrowCls} />
          {children}
        </SectionContent>
      </Wrapper>
    </Section>
  ) : null;
